import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './quill.css'
import { cn } from '../../../../../lib/utils'

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
}

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'link',
]

interface RichTextEditorProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  className,
}) => {
  return (
    <div className="w-full">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        className={cn('bg-white rounded-md', className)}
      />
    </div>
  )
}

interface RichTextViewerProps {
  value: string
  className?: string
}

export const RichTextViewer: React.FC<RichTextViewerProps> = ({
  value,
  className,
}) => {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      style={{
        border: 'none',
      }}
      readOnly={true}
      modules={{ toolbar: false }}
      formats={formats}
      className={cn('bg-white rounded-md', className)}
    />
  )
}

export default RichTextEditor
